import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

import LOGO from '../assets/DS_Logomark--Gradient_Dark.png';
import SPINNING_LOGO from '../assets/dsSpinnerLogo.gif';


/**
 * DialSource Logo
 */
const Logo = ({ spinning }) => (
  <Image src={spinning ? SPINNING_LOGO : LOGO} alt={spinning ? 'Loading' : 'DialSource'} />
);

export default Logo;

Logo.propTypes = {
  spinning: PropTypes.bool.isRequired,
};

Logo.defaultProps = {
  spinning: false,
};
